import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const fixed = {
  pinArticleAtSection: lazyModuleMethod(
    () => import('./pinArticleAtSection'),
    'default'
  ),
  unpinArticleAtSection: lazyModuleMethod(
    () => import('./unpinArticleAtSection'),
    'default'
  ),
  fetchFixeds: lazyModuleMethod(() => import('./fetchFixeds'), 'default'),
  createFixedArticle: lazyModuleMethod(
    () => import('./createFixedArticle'),
    'default'
  ),
  deleteFixedArticle: lazyModuleMethod(
    () => import('./deleteFixedArticle'),
    'default'
  ),
  createPinnedArticle: lazyModuleMethod(
    () => import('./createPinnedArticle'),
    'default'
  ),
  deletePinnedArticle: lazyModuleMethod(
    () => import('./deletePinnedArticle'),
    'default'
  ),
  deletePopblock: lazyModuleMethod(() => import('./deletePopblock'), 'default'),
  deleteContest: lazyModuleMethod(() => import('./deleteContest'), 'default'),
  updateFixedArticle: lazyModuleMethod(
    () => import('./updateFixedArticle'),
    'default'
  ),
  sortFixedArticle: lazyModuleMethod(
    () => import('./sortFixedArticle'),
    'default'
  ),
}
